import { Component } from '@angular/core';

@Component({
	selector: 'yem-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css'],
})
export class AppComponent {
	title = 'visor-agenda';
}
